import React from 'react';

const Home = () => {

  return (
    <main>
     <p>Welcome to <span>Gaming Geeks</span>! <br />
     🎮 <br />
      Connect with gamers worldwide on our gaming chatroom website. <br />
      Chat, share tips, and discuss strategy. <br />
      Join our community and indulge in your passion for gaming!</p>
      <br />
      - GG Team <br />
    </main>
  );
};

export default Home;